import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const get34ActiveBets=()=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_34_ACTIVE_BETS_START
    });
    axios.get('/twoDBets')
         .then(response=>dispatch({
             type:actionTypes.GET_34_ACTIVE_BETS_SUCCESS,
             payload:response.data
         }))
         .catch(err=>dispatch({
             type:actionTypes.GET_34_ACTIVE_BETS_FAIL,
             payload:getMessage(err)
         }))
}